import React from "react";
import Navbar from "./global-components/navbar-v2";
import PageHeader from "./global-components/page-header";
import Service from "./section-components/service-v5";
import Cta from "./section-components/cta-v10";
import FaqV2 from "./section-components/faq-v2";
import Testimonial from "./section-components/testimonial-v2";
import Brand from "./section-components/brand-v4";
import Case from "./section-components/case";
import Footer from "./global-components/footer-v2";

const ServiceV1 = () => {
  let ServiceObject = {
    serviceHeading:
      "Build and Engage Online Communities across Platforms. Tap into the broad reach of social media to attract, engage, and develop brand loyalty. Utilize data-driven strategies, robust analytics, and tailored campaigns to optimize performance and achieve your company objectives.",
    servicePointsLoop: [
      "Generate captivating content and strategically target specific groups to attract and engage your ideal customers.",
      "Regular and authentic interactions foster trust, credibility, and loyalty among followers, leading to increased brand advocacy and word-of-mouth referrals.",
      "Leverage robust analytics and reporting tools provided by social media networks to track campaign performance in real time.",
      "Our services are tailored to align with your company objectives and target your ideal customers.",
    ],
    serviceDiv: [
      {
        heading: "Broad Reach & Targeted Engagement",
        description: "Broad reach and targeted engagement across social media platforms.",
      },
      {
        heading: "Brand Building and Online Presence",
        description:
          "Brand building and strong online presence through authentic interactions.",
      },
      {
        heading: "Data-Driven Optimization",
        description: "Data-driven optimization for enhanced campaign performance.",
      },
      {
        heading: "Tailored Campaigns for Business Objectives",
        description:
          "Tailored social media campaigns aligned with business objectives.",
      },
    ],
  };
  let workWithUs =
    "Unlock the Power of Social Media Marketing by Partnering with Us. Our tailored campaigns, data-driven strategies, and focus on building brand engagement will help you achieve your business objectives and maximize the impact of your social media presence.";

  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Social Media Marketing" />
      <Service serviceDetail={ServiceObject} />
      <Cta workWithUs={workWithUs} />
      <FaqV2 />
      <Testimonial />
      <Brand />
      <Case customclass="case-one case-one__team-page case-one__service-page" />
      <Footer />
    </div>
  );
};

export default ServiceV1;
